import { render, staticRenderFns } from "./PrivacyPolicyEdit.vue?vue&type=template&id=2c977a08&scoped=true&"
import script from "./PrivacyPolicyEdit.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyEdit.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyEdit.vue?vue&type=style&index=0&id=2c977a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c977a08",
  null
  
)

export default component.exports